var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiltiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 147,
    viewBox: "0 0 316 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.452 11H20.4424C15.2275 11 11 15.2708 11 20.5391V126.662C11 131.93 15.2275 136.201 20.4424 136.201H295.452C300.667 136.201 304.894 131.93 304.894 126.662V20.5391C304.894 15.2708 300.667 11 295.452 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5371,
    y: 40.8438,
    width: 212,
    height: 65,
    fill: "url(#pattern0_17_864)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_864",
    x: 0,
    y: 0,
    width: 315.895,
    height: 147.201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_864"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_864",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_17_864",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_17_864",
    transform: "matrix(0.00444444 0 0 0.0144957 0 -0.486154)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_17_864",
    width: 225,
    height: 135,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/jpeg;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiltiLogo);
export default __webpack_public_path__ + "static/media/hilti-logo.fd8d37cc5395ecd36008fdcf3e11a491.svg";
export { ForwardRef as ReactComponent };